
import { defineStore } from "pinia";
import { Local } from '@/utils/storage'
import { getAdminPermissions } from '@/api'
export const useSystemStore = defineStore("system", {
    state: () => {
        return {
            admin_name: Local.get("managerInfo")?.real_name || '登录',
            current_mechanism: Local.get("current_mechanism") || {},
            mechanism_list: Local.get("mechanism_list") || [],
            categories_list: [],
            area_list: [],
            permissionCodes: Local.get('permissionCodes') || []
        }
    },
    actions: {
        getPermissions() {
            if (!Local.get("managerInfo")) {
                return
            }
            let permissionCodes = Local.get('permissionCodes')
            if (!permissionCodes) {
                getAdminPermissions().then((res:any) => {
                    let menus:string[] = []
                    let btns:string[] = []
                    let apis:string[] = []
                    res.data.forEach((item:any) => {
                        if (item.permission_type == 1) {
                            menus.push(item.permission_code)
                        } else if (item.permission_type == 2) {
                            btns.push(item.permission_code)
                        } else if (item.permission_type == 3) {
                            apis.push(item.permission_code)
                        }
                    });

                    this.permissionCodes = menus;
                    Local.set("permissionCodes", menus);
                    Local.set("permissionBtnss", btns);
                    Local.set("permissionApis", apis);
                    
                })
            }

        }
    }
})